import Vue from 'vue';
import Router from 'vue-router';
import DashView from '@/layouts/Dash.vue';
import Receipts from '@/views/Receipts.vue';
import store from './store/index';
import AuthGuard from './AuthGuard';

Vue.use(Router);
const redirectBasedOnLoackDownStatus = (next) => {
  if (store.getters['users/LockDownStatus']) {
    next('/');
  } else {
    next();
  }
};
const redirectBasedOntypeId = (next) => {
  if (store.getters['users/me']) {
    const user = store.getters['users/me'];
    if (user.typeId !== '' && user.typeId !== null) {
      next();
    } else {
      next('/');
    }
  }
};
export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  methods: {

  },
  routes: [
    {
      path: '/auth',
      name: 'auth-view',
      component: () => import('@/layouts/Auth.vue'),
      // component: AuthView,
      children: [
        {
          path: '/sign-in',
          name: 'sign-in',
          component: () => import('@/views/auth/SignIn.vue'),
          // component: SignIn,
        },
        {
          path: '/sign-up',
          name: 'sign-up',
          component: () => import('@/views/auth/SignUpSingle.vue'),
          // component: SignUpSingle,
        },
        {
          path: '/sign-up/org',
          name: 'sign-up',
          component: () => import('@/views/auth/SignUp.vue'),
          // component: SignUp,
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('./views/auth/ForgotPassword.vue'),
          // component: ForgotPassword,
        },
        {
          path: '/reset-password/:id/:code',
          name: 'ForgotPasswordConform',
          component: () => import('@/views/auth/ForgotPasswordConform.vue'),
          // component: ForgotPasswordConform,
          props: true,
        },
        {
          path: '/confirm-edit-email/:id/:code/:region',
          name: 'ConfirmEditEmail',
          component: () => import('@/views/auth/ConfirmEditEmail.vue'),
          // component: ConfirmEditEmail,
          props: true,
        },
        {
          path: '/confirm-email/:id/:code/:region/:cId?',
          name: 'ConfirmEmail',
          component: () => import('@/views/auth/ConfirmEmail.vue'),
          // component: ConfirmEmail,
          props: true,
        },
        {
          path: '/verify-sign-in-code/:id/:code',
          name: 'VerifySignInCode',
          component: () => import('@/views/auth/VerifySignInCode.vue'),
          // component: VerifySignInCode,
          props: true,
        },
        {
          path: '/verify-sign-in-otp/:id/:code',
          name: 'VerifySignInOTP',
          component: () => import('@/views/auth/VerifySignInOTP.vue'),
          // component: VerifySignInOTP,
          props: true,
        },
      ],
    },
    {
      path: '/',
      name: 'dash-view',
      component: DashView,
      beforeEnter: AuthGuard,

      children: [
        {
          path: '/dashboard/:companyId',
          name: 'dashboard',
          component: () => import('@/views/Dashboard.vue'),
          // component: Dashboard,
          meta: {
            title: 'Dashboard',
            slug: 'dashboard',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
        },
        {
          path: '/dashboard',
          alias: '/',
          name: 'dashboard',
          component: () => import('@/views/Dashboard.vue'),
          // component: Dashboard,
          meta: {
            title: 'Dashboard',
            slug: 'dashboard',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
        },
        // {
        //   path: '/parent',
        //   name: 'parent',
        //   component: () => import('@/views/Parent.vue'),
        //   // component: Parent,
        // },

        {
          path: '/static-chart',
          name: 'StaticChart',
          component: () => import('@/views/StaticChart.vue'),
          // component: StaticChart,
        },
        {
          path: '/virtual-cards',
          name: 'virtualCards',
          component: () => import('@/views/cards-virtual/Index.vue'),
          // component: CardIndex,
          meta: {
            title: 'Virtual Cards',
            slug: 'virtual-cards',
            hideGroupsDropdown: false,
            hideGroupsDropdown2: true,
          },
          children: [
            {
              path: '/virtual-cards/:categoryId/:teamId',
              name: 'virtualCardChild1',
              component: () => import('@/views/cards-virtual/CardsVirtualHome.vue'),
              // component: CardVirtualHome,
              meta: {
                title: 'Virtual Cards',
                slug: 'virtual-cards1',
                hideGroupsDropdown: false,
                hideGroupsDropdown2: true,
              },
            },
            {
              path: '/virtual-cards/:teamId',
              name: 'virtualCardChild2',
              component: () => import('@/views/cards-virtual/CardsTeamsLanding.vue'),
              // component: CardsTeamsLanding,
              meta: {
                title: 'Virtual Cards',
                slug: 'virtual-cards2',
                hideGroupsDropdown: false,
                hideGroupsDropdown2: true,
              },
            },
          ],
        },
        {
          path: '/physical-cards',
          name: 'physicalCardsHome',
          component: () => import('@/views/cards-physical/IndexPhysicalCards.vue'),
          // component: CardPhysicalHomeIndex,
          meta: {
            title: 'Credit Cards',
            slug: 'physicalCardsHome',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          children: [
            {
              path: '/physical-cards/:teamId',
              name: 'physicalCards',
              component: () => import('@/views/cards-physical/CardsPhysicalHome.vue'),
              // component: CardPhysicalHome,
              props: true,
              meta: {
                title: 'Credit Cards',
                slug: 'physicalCards',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
                parentPath: '/physical-cards',
              },
            },
          ],
        },
        {
          path: '/credit-card-statement',
          name: 'CreditCardStatement',
          component: () => import('@/views/CreditCardStatement.vue'),
          // component: CreditCardStatement,
          meta: {
            title: 'Credit Card Statement',
            slug: 'credit-card-statement',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
        },
        {
          path: '/cards',
          name: 'cards',
          // component: Cards,
          component: () => import('@/views/cards/index.vue'),
          beforeEnter(_to, _from, next) {
            redirectBasedOnLoackDownStatus(next);
          },
          meta: {
            title: 'Cards',
            slug: 'Cards',
            hideGroupsDropdown: false,
            hideGroupsDropdown2: true,
          },
          children: [
            {
              path: '/cards/:cardId',
              name: 'CardLendingPage',
              // component: CardLendingPage,
              component: () => import('@/views/cards/CardLendingPage'),
              meta: {
                title: 'Cards\' Transactions',
                slug: 'transactions-cards',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: false,
                parentPath: '/cards/all',
                hideOldLoader: true,
              },
            },
            {
              path: '/cards/all',
              name: 'CardLendingPage',
              // component: CardLendingPage,
              component: () => import('@/views/cards/CardLendingPage'),
              meta: {
                title: 'Cards\' Transactions',
                slug: 'transactions-cards',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: false,
              },
            },
          ],
        },
        {
          path: '/transactions',
          name: 'transactions',
          component: () => import('@/views/transactions/Index.vue'),
          beforeEnter(_to, _from, next) {
            redirectBasedOnLoackDownStatus(next);
          },
          meta: {
            title: 'Transactions',
            slug: 'transactions',
            hideGroupsDropdown: false,
            hideGroupsDropdown2: true,
          },
          children: [
            {
              // New link added in order to see logged in user's own transactions only
              path: '/my/transactions',
              name: 'myTransactions',
              component: () => import('@/views/transactions/MyTransactions.vue'),
              meta: {
                title: 'My Transactions',
                slug: 'my-transactions',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: false,
                parentPath: '/transactions/all/team/category',
                hideOldLoader: true,
              },
            },
            {
              // Bulk transactions route - uses same component as my transactions
              path: '/bulk/transactions',
              name: 'bulkTransactions',
              component: () => import('@/views/transactions/MyTransactions.vue'),
              meta: {
                title: 'Bulk Transactions',
                slug: 'bulk-transactions',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: false,
                parentPath: '/transactions/all/team/category',
                hideOldLoader: true,
              },
            },
            {
              path: '/transactions/:teamId',
              name: 'TransactionTeamsLanding',
              // component: TransactionTeamsLanding,
              component: () => import('@/views/transactions/TransactionTeamsLanding.vue'),
              meta: {
                title: 'Transactions',
                slug: 'transactions-category',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: false,
                parentPath: '/transactions/all/team/category',
                hideOldLoader: true,
              },
            },
            {
              path: '/transactions/:categoryId/:teamId',
              name: 'TransactionHome',
              // component: TransactionHome,
              component: () => import('@/views/transactions/TransactionHome.vue'),
              meta: {
                title: 'Transactions',
                slug: 'transactions-user',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: false,
                parentPath: '/transactions/all/team/category',
                hideOldLoader: true,
              },
            },
            {
              path: '/transactions/all/team/category/:onlyteamId',
              name: 'AllTransactionTeamwise',
              // component: AllTransactionTeamwise,
              component: () => import('@/views/transactions/AllTransactionTeamwise.vue'),
              meta: {
                title: 'Transactions',
                slug: 'transactions-teamwise',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: false,
                parentPath: '/transactions/all/team/category',
                hideOldLoader: true,
              },
            },
            {
              path: '/transactions/all/team/category',
              name: 'AllTransaction',
              // component: AllTransaction,
              component: () => import('@/views/transactions/AllTransaction.vue'),
              meta: {
                title: 'Transactions',
                slug: 'transactions-user',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: false,
                hideOldLoader: true,
              },
            },
            {
              path: '/transactions/recentlycategorized/team/category',
              name: 'RecentlyCategorizedTransactions',
              component: () => import('@/views/transactions/RecentlyCategorizedTransactions.vue'),
              beforeEnter(_to, _from, next) {
                // Check if bulk transactions mode is enabled
                const { isBulkTransactionsEnabled } = require('@/utils/bulkTransactionsHelper');
                if (isBulkTransactionsEnabled()) {
                  // If in bulk mode, redirect to bulk transactions
                  next('/bulk/transactions');
                } else {
                  next();
                }
              },
              meta: {
                title: 'Recently Categorized Transactions',
                slug: 'transactions-user',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
              },
            },
          ],
        },
        {
          path: '/budget',
          name: 'budget',
          beforeEnter(_to, __from, next) {
            redirectBasedOnLoackDownStatus(next);
          },
          // component: BudgetIndex,
          component: () => import('@/views/budget/Index.vue'),
          meta: {
            title: 'Budgets',
            slug: 'newBudgetHome',
            hideGroupsDropdown: false,
            hideGroupsDropdown2: true,
          },
          children: [
            {
              path: '/budget/allTeam',
              name: 'BudgetScreen',
              // component: BudgetScreen,
              component: () => import('@/views/budget/budgetScreen.vue'),
              meta: {
                title: 'Budgets',
                slug: 'BudgetScreen',
                hideGroupsDropdown: false,
                hideGroupsDropdown2: true,
              },
            },
            {
              path: '/budget/:categoryId/:teamId',
              name: 'newBudgetCat',
              // component: BudgetHome,
              component: () => import('@/views/budget/BudgetHome.vue'),
              meta: {
                title: 'Budgets',
                slug: 'newBudgetCat',
                hideGroupsDropdown: false,
                hideGroupsDropdown2: true,
                parentPath: '/budget/allTeam',
              },
            },
            {
              path: '/budget/:categoryId/:teamId/:month/:year',
              name: 'newBudgetCatWithMonth',
              // component: BudgetHome,
              component: () => import('@/views/budget/BudgetHome.vue'),
              meta: {
                title: 'Budgets',
                slug: 'newBudgetCatWithMonth',
                hideGroupsDropdown: false,
                hideGroupsDropdown2: true,
                parentPath: '/budget/allTeam',
              },
            },
            {
              path: '/budget/:teamId',
              name: 'newBudgetTeam',
              // component: BudgetsTeamsLanding,
              component: () => import('@/views/budget/BudgetsTeamsLanding.vue'),
              meta: {
                title: 'Budgets',
                slug: 'newBudget',
                hideGroupsDropdown: false,
                hideGroupsDropdown2: true,
                parentPath: '/budget/allTeam',
              },
            },

            {
              path: '/budget/:teamId/:month/:year',
              name: 'newBudgetTeamWithMontadnYear',
              // component: BudgetsTeamsLanding,
              component: () => import('@/views/budget/BudgetsTeamsLanding.vue'),
              meta: {
                title: 'Budgets',
                slug: 'newBudget',
                hideGroupsDropdown: false,
                hideGroupsDropdown2: true,
                parentPath: '/budget/allTeam',
              },
            },
          ],
        },
        {
          path: '/employees',
          name: 'Employees',
          beforeEnter(_to, __from, next) {
            redirectBasedOnLoackDownStatus(next);
          },
          // component: Employees,
          component: () => import('@/views/employees/Index.vue'),
          meta: {
            title: 'Employees',
            slug: 'employees',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          children: [
            {
              path: '/employees/:employeeId/edit',
              name: 'Employee',
              // component: EmployeeEdit,
              component: () => import('@/views/employees/Edit.vue'),
              meta: {
                title: 'Edit Employee',
                slug: 'edit-employee',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
                parentPath: '/employees',
              },
            },
            {
              path: '/employees/user',
              name: 'EmployeeNew',
              // component: EmployeeEdit,
              component: () => import('@/views/employees/Edit.vue'),
              meta: {
                title: 'Add Employee',
                slug: 'new-employee',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
              },
            },
            {
              path: '/employees/newuser',
              name: 'EmployeeNew',
              // component: AddNewEmployee,
              component: () => import('@/views/employees/Add.vue'),

              meta: {
                title: 'Add Employee',
                slug: 'new-employee',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
              },
            },
          ],
        },
        {
          path: '/profile-and-settings',
          alias: '',
          name: 'Profile',
          // component: Profile,
          component: () => import('@/views/Profile.vue'),
        },
        {
          path: '/change-password',
          alias: '',
          name: 'ChangePassword',
          // component: ChangePassword,
          component: () => import('@/views/ChangePassword.vue'),
          meta: {
            title: 'Change Password',
            slug: 'change-password',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
        },
        {
          path: '/about',
          name: 'about',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('./views/About.vue'),
          meta: {
            title: 'About',
            slug: 'about',
          },
        },
        // {
        //   path: '/static-teams',
        //   name: 'StaticTeams',
        //   component: StaticTeams,
        //   meta: {
        //     title: 'Static Teams',
        //     slug: 'static-teams',
        //     hideGroupsDropdown: true,
        //     hideGroupsDropdown2: true,
        //   },
        //   children: [
        //     {
        //       path: '/static-teams/:teamId/edit',
        //       name: 'StaticTeam',
        //       component: StaticTeamEdit,
        //       meta: {
        //         title: 'Static Edit Team',
        //         slug: 'static-edit-team',
        //         hideGroupsDropdown: true,
        //         hideGroupsDropdown2: true,
        //       },
        //     },
        //     {
        //       path: '/static-teams/new',
        //       name: 'StaticTeamNew',
        //       component: StaticTeamEdit,
        //       meta: {
        //         title: 'Static Add Team',
        //         slug: 'static-new-team',
        //         hideGroupsDropdown: true,
        //         hideGroupsDropdown2: true,
        //       },
        //     },
        //   ],
        // },
        {
          path: '/mycompany',
          name: 'MyCompany',
          // component: MyCompany,
          component: () => import('@/views/my-company/Index.vue'),
          beforeEnter(_to, __from, next) {
            redirectBasedOnLoackDownStatus(next);
          },
          meta: {
            title: 'My Company',
            slug: 'MyCompany',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          children: [
            {
              path: '/mycompany/:companyId/edit',
              name: 'Company',
              // component: MyCompanyEdit,
              component: () => import('@/views/my-company/Edit.vue'),
              meta: {
                title: 'Company Edit',
                slug: 'companyEdit',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
                parentPath: '/mycompany',
              },
            },
            {
              path: '/mycompany/new',
              name: 'CompanyNew',
              // component: MyCompanyEdit,
              component: () => import('@/views/my-company/Edit.vue'),
              meta: {
                title: 'Add Child Company',
                slug: 'new-childCompany',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
              },
            },
          ],
        },
        {
          path: '/teams',
          name: 'Teams',
          // component: Teams,
          component: () => import('@/views/teams/Index.vue'),
          beforeEnter(_to, _from, next) {
            redirectBasedOnLoackDownStatus(next);
          },
          meta: {
            title: 'Teams',
            slug: 'teams',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          children: [
            {
              path: '/teams/:teamId/edit',
              name: 'Team',
              // component: TeamEdit,
              component: () => import('@/views/teams/Edit.vue'),
              meta: {
                title: 'Edit Team',
                slug: 'edit-team',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
                parentPath: '/teams',
              },
            },
            {
              path: '/teams/new',
              name: 'TeamNew',
              // component: TeamEdit,
              component: () => import('@/views/teams/Edit.vue'),
              meta: {
                title: 'Add Team',
                slug: 'new-team',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
              },
            },
          ],
        },
        {
          path: '/companies',
          name: 'Companies',
          meta: {
            title: 'Companies',
            slug: 'companies',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: companies,
          component: () => import('@/views/Companies.vue'),
          beforeEnter(_to, _from, next) {
            redirectBasedOntypeId(next);
          },
        },
        {
          path: '/marqeta-transaction-list',
          name: 'API Transactions',
          meta: {
            title: 'API Transactions',
            slug: 'marqeta-transaction-list',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: companies,
          component: () => import('@/views/marqeta-utility/transactionlist.vue'),
          beforeEnter(_to, _from, next) {
            redirectBasedOntypeId(next);
          },
        },
        {
          path: '/sadmin-dashboard',
          name: 'sadmin-dashboard',
          meta: {
            title: 'Dashboard',
            slug: 'sadmin-dashboard',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: SAdminDashboard,
          component: () => import('@/views/SAdminDashboard.vue'),
          beforeEnter(_to, _from, next) {
            redirectBasedOntypeId(next);
          },
        },
        {
          path: '/sadmin-dashboard/cards-list/:filterBy/:selectedCardType',
          name: 'sadmin-cards-list',
          meta: {
            title: 'Registered Cards List',
            slug: 'sadmin-cards-list',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
            showCloseIcon: true,
          },
          // component: RegisteredCardsList,
          component: () => import('@/views/super-admin/RegisteredCardsList.vue'),
          beforeEnter(to, from, next) {
            if (store.getters['users/me']) {
              const user = store.getters['users/me'];
              if (user.typeId !== '' && user.typeId !== null) {
                next();
              } else {
                next('/');
              }
            }
          },
        },
        {
          path: '/sadmin-dashboard/companies-list/:filterBy',
          name: 'sadmin-companies-list',
          meta: {
            title: 'Registered Companies List',
            slug: 'sadmin-companies-list',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
            showCloseIcon: true,
          },
          // component: RegisteredCompaniesList,
          component: () => import('@/views/super-admin/RegisteredCompaniesList.vue'),
          beforeEnter(to, from, next) {
            if (store.getters['users/me']) {
              const user = store.getters['users/me'];
              if (user.typeId !== '' && user.typeId !== null) {
                next();
              } else {
                next('/');
              }
            }
          },
        },
        {
          path: '/support-admins',
          name: 'Support Admins List',
          // component: CompanySupportAdminList,
          component: () => import('@/views/super-admin/CompanySupportAdminList.vue'),
          meta: {
            title: 'Support Admins List',
            slug: 'support-admin-list',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          beforeEnter(to, from, next) {
            if (store.getters['users/me']) {
              const user = store.getters['users/me'];
              if (user.typeId) {
                next();
              } else {
                next('/');
              }
            }
          },
          children: [
            {
              path: '/support-admins/new',
              name: 'Support Admins',
              meta: {
                title: 'Add Support Admin',
                slug: 'support-admin-new',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
              },
              // component: CompanySupportAdminEdit,
              component: () => import('@/views/super-admin/CompanySupportAdminEdit.vue'),
              beforeEnter(to, from, next) {
                if (store.getters['users/me']) {
                  const user = store.getters['users/me'];
                  console.log(user);
                  if (user.typeId) {
                    next();
                  } else {
                    next('/');
                  }
                }
              },
            },
            {
              path: '/support-admins/:supportAdminId/edit',
              name: 'Support Admins',
              meta: {
                title: 'Edit Support Admin',
                slug: 'support-admin-edit',
                hideGroupsDropdown: true,
                hideGroupsDropdown2: true,
              },
              // component: CompanySupportAdminEdit,
              component: () => import('@/views/super-admin/CompanySupportAdminEdit.vue'),
              beforeEnter(to, from, next) {
                if (store.getters['users/me']) {
                  const user = store.getters['users/me'];
                  if (user.typeId) {
                    next();
                  } else {
                    next('/');
                  }
                }
              },
            },
          ],
        },

        {
          path: '/merchants',
          name: 'Merchants',
          meta: {
            title: 'Merchants',
            slug: 'merchants',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: merchants,
          component: () => import('@/views/Merchants.vue'),
          beforeEnter(to, from, next) {
            if (store.getters['users/me']) {
              const user = store.getters['users/me'];
              if (user.typeId !== '' && user.typeId !== null) {
                next();
              } else {
                next('/');
              }
            }
          },
        },
        {
          path: '/company-payment',
          name: 'CompanyPayment',
          meta: {
            title: 'Company Payment',
            slug: 'company-payment',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: CompanyPayment,
          component: () => import('@/views/CompanyPayment.vue'),
          beforeEnter(to, from, next) {
            if (store.getters['users/me']) {
              const user = store.getters['users/me'];
              const typeName = store.getters['managerole/userTypeName'];
              if (typeName === 'Super Admin') {
                next();
              } else if (typeName === 'Support Admin') {
                const recordIndex = user.supportAdminPermissions.findIndex(permission => permission.slug === 'company_ledger_screen_access');
                if (recordIndex >= 0) {
                  next();
                } else {
                  next('/companies');
                }
              } else {
                next('/');
              }
            }
          },
        },
        {
          path: '/company-members',
          name: 'CompanyUsers',
          meta: {
            title: 'Company Members',
            slug: 'company-members',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: CompanyUsers,
          component: () => import('@/views/CompanyUsers.vue'),
          beforeEnter(to, from, next) {
            if (store.getters['users/me']) {
              const user = store.getters['users/me'];
              const typeName = store.getters['managerole/userTypeName'];
              if (typeName === 'Super Admin') {
                next();
              } else if (typeName === 'Support Admin') {
                const recordIndex = user.supportAdminPermissions.findIndex(permission => permission.slug === 'company_members_screen_access');
                if (recordIndex >= 0) {
                  next();
                } else {
                  next('/companies');
                }
              } else {
                next('/');
              }
            }
          },
        },
        {
          path: '/manual-payment',
          name: 'ManualPayment',
          meta: {
            title: 'Manual Payment',
            slug: 'manual-payment',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: ManualPayment,
          component: () => import('@/views/ManualPayment.vue'),
          beforeEnter(to, from, next) {
            if (store.getters['users/me']) {
              const user = store.getters['users/me'];
              const typeName = store.getters['managerole/userTypeName'];
              if (typeName === 'Super Admin') {
                next();
              } else if (typeName === 'Support Admin') {
                const recordIndex = user.supportAdminPermissions.findIndex(permission => permission.slug === 'manual_payments_screen_access');
                if (recordIndex >= 0) {
                  next();
                } else {
                  next('/companies');
                }
              } else {
                next('/');
              }
            }
          },
        },
        {
          path: '/manage-company/bank-account',
          name: 'ManageCompanyBankAccount',
          meta: {
            title: 'Bank Account',
            slug: 'bank-account',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: ManageCompanyBankAccount,
          component: () => import('@/views/company-admin/manage-company/BankAccount.vue'),
        },
        {
          path: '/manage-company/cc-account',
          name: 'ManageCreditCardAccount',
          meta: {
            title: 'Credit Card Account',
            slug: 'credit-card-account',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: ManageCreditCardAccount,
          component: () => import('@/views/company-admin/manage-company/CreditCardAccount.vue'),
        },
        {
          path: '/manage-company/map-category',
          name: 'MappingPlaidTransactions',
          meta: {
            title: 'Map Category',
            slug: 'map-plaid-category',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: MappingPlaidTransactions,
          component: () => import('@/views/company-admin/manage-company/MappingPlaidTransactions.vue'),
        },
        {
          path: '/manage-company/payment',
          name: 'ManageCompanyPayment',
          meta: {
            title: 'Payment',
            slug: 'payment',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: ManageCompanyPayment,
          component: () => import('@/views/company-admin/manage-company/Payment.vue'),
        },
        {
          path: '/accounting-integration',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingIntegration',
          meta: {
            title: 'Accounting',
            slug: 'accounting-integration',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: false,
          },
          // component: AccountingIntegration,
          component: () => import('@/views/company-admin/accounting-integration/Index.vue'),
        },
        {
          path: '/accounting-integration/quick-book',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemQuickBook',
          meta: {
            title: 'Accounting System - Quick Book',
            slug: 'accounting-system-quick-book',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: AccountingSystemQuickBook,
          component: () => import('@/views/company-admin/accounting-integration/QuickBook.vue'),
        },
        {
          path: '/accounting-integration/xero',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemXero',
          meta: {
            title: 'Accounting System - Xero',
            slug: 'accounting-system-xero',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: AccountingSystemXero,
          component: () => import('@/views/company-admin/accounting-integration/Xero.vue'),
        },
        {
          path: '/accounting-integration/accsys-agillinkuploadfile',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemAgilLinkUploadFile',
          meta: {
            title: 'Accounting System - AgilLink',
            slug: 'accounting-system-agillinkuploadfile',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },

          component: () => import('@/views/company-admin/accounting-integration/AccSysAgilLinkUploadFile.vue'),
        },
        {
          path: '/accounting-integration/agil-link-online/:firmCode',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemAgilLinkOnline',
          meta: {
            title: 'Accounting System - AgilLink',
            slug: 'agil-link-online',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          component: () => import('@/views/company-admin/accounting-integration/AgilLinkOnline.vue'),
        },
        {
          path: '/accounting-integration/accsys-remapcreditcardaccounts',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemReMapCreditCardAccounts',
          meta: {
            title: 'Re-map Credit Card Accounts',
            slug: 'accounting-system-remapcreditcardaccounts',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          component: () => import('@/views/company-admin/accounting-integration/AccSysReMapCreditCardAccounts.vue'),
        },
        {
          path: '/accounting-integration/accsys-remapduefromaccount',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemReMapDueFromAccount',
          meta: {
            title: 'Re-map Due from Account',
            slug: 'accounting-system-remapduefromaccount',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          component: () => import('@/views/company-admin/accounting-integration/AccSysReMapDueFromAccount.vue'),
        },
        {
          path: '/accounting-integration/accsys-remapduetoaccount',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemReMapDueToAccount',
          meta: {
            title: 'Re-map Due to Account',
            slug: 'accounting-system-remapduetoaccount',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          component: () => import('@/views/company-admin/accounting-integration/AccSysReMapDueToAccount.vue'),
        },
        {
          path: '/accounting-integration/accsys-remapbankaccounts',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemReMapBankAccounts',
          meta: {
            title: 'Re-map Bank Accounts',
            slug: 'accounting-system-remapbankaccounts',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          component: () => import('@/views/company-admin/accounting-integration/AccSysReMapBankAccounts.vue'),
        },
        {
          path: '/accounting-integration/accsys-remapcategories',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AccountingSystemReMapCategories',
          meta: {
            title: 'Re-map Categories',
            slug: 'accounting-system-remapcategories',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          component: () => import('@/views/company-admin/accounting-integration/AccSysReMapCategories.vue'),
        },
        {
          path: '/accounting-integration/accsys-remaptags/:metaTitle?',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              if (to.params.metaTitle) {
                to.meta.title = to.params.metaTitle;
              }
              next();
            }
          },
          name: 'AccountingSystemReMapTags',
          meta: {
            title: 'Re-map Classes',
            slug: 'accounting-system-remaptags',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          component: () => import('@/views/company-admin/accounting-integration/AccSysReMapTags.vue'),
        },
        {
          path: '/accounting-integration/accsys-remapteams/:metaTitle?',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              if (to.params.metaTitle) {
                to.meta.title = to.params.metaTitle;
              }
              next();
            }
          },
          name: 'AccountingSystemReMapTeams',
          meta: {
            title: 'Re-map Divisions',
            slug: 'accounting-system-remapteams',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          component: () => import('@/views/company-admin/accounting-integration/AccSysReMapTeams.vue'),
        },
        {
          path: '/accounting-integration/agilLink-remapcategories',
          beforeEnter(to, from, next) {
            const user = store.getters['users/me'];
            if (store.getters['users/LockDownStatus'] || !user.currentCompUserSettings[0].accountingSystemAccess) {
              next('/');
            } else {
              next();
            }
          },
          name: 'AgilLinkReMapCategories',
          meta: {
            title: 'Re-map Categories',
            slug: 'agilLink-remapcategories',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
          // component: AgilLinkReMapCategories,
          component: () => import('@/views/company-admin/accounting-integration/AgilLinkReMapCategories.vue'),
        },
        {
          path: '/journal-entry',
          beforeEnter(to, from, next) {
            if (store.getters['users/LockDownStatus']) {
              next('/');
            } else {
              next();
            }
          },
          name: 'Journal Entry',
          meta: {
            title: 'Journal Entry',
            slug: 'journal-entry',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: false,
          },
          // component: JournalEntry,
          component: () => import('@/views/company-admin/journal-entry/Index.vue'),
        },
        {
          path: '/reports',
          beforeEnter(to, from, next) {
            if (store.getters['users/LockDownStatus']) {
              next('/');
            } else {
              next();
            }
          },
          name: 'Reports',
          meta: {
            title: 'Reports',
            slug: 'reports',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: false,
          },
          // component: Reports,
          component: () => import('@/views/company-admin/reports/Index.vue'),
        },
      ],
    },
    {
      path: '/receipt',
      name: 'reciept-view',
      component: Receipts,
      children: [
        {
          path: '/receipt/:transactionId',
          name: 'receipts',
          component: () => import('@/views/Receipts.vue'),
          // component: Dashboard,
          meta: {
            title: 'Receipts',
            slug: 'receipt',
            hideGroupsDropdown: true,
            hideGroupsDropdown2: true,
          },
        },
      ]
    },
  ],
});
